module.exports = __webpack_public_path__ + "img/Friends.e0d9a574.png";